// Access the strings used on the PopUp Message.
export const t_popUp = {
    titlePrefix: "popUp.titlePrefix",
    titleError: "popUp.titleError",
    titleNetworkError: "popUp.titleNetworkError",
    bodyTextError: "popUp.bodyTextError",
    bodyTextNetworkError: "popUp.bodyTextNetworkError",
    bodyText: "popUp.bodyText",
    contactSubtitle: "popUp.contactSubtitle",
    moreDetailsLink: "popUp.moreDetailsLink",
    detailsToggle: "popUp.detailsToggle",
    dismissButton: "popUp.dismissButton",
  };
